import script from "./SubscriptionPushTt.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPushTt.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPushTt.vue?vue&type=style&index=0&id=47f6175e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f6175e"]])

export default __exports__